import { Injectable } from '@angular/core';
import {
	Router, Resolve,
	RouterStateSnapshot,
	ActivatedRouteSnapshot
} from '@angular/router';
import { NEVER, Observable, of } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { JobBriefInfo } from '../models/my-work/job-brief-info.model';
import { JobLogbook } from '../models/my-work/job-logbook.model';
import { MyWorkJob } from '../models/my-work/my-work-job.model';
import { BinderWizardService } from '../services/sections/binder/binder-wizard.service';
import { GlobalSettingsService } from '../services/ui/global-settings.service';

@Injectable({
	providedIn: 'root'
})
export class DigitalLogbooksResolver implements Resolve<Observable<MyWorkJob[]>> {
	constructor(
		private router: Router,
		private binderService: BinderWizardService
	) { }

	resolve(activatedRouteSnapshot: ActivatedRouteSnapshot, routerStateSnapshot: RouterStateSnapshot) {
		GlobalSettingsService.isSecondaryLoaderLoading = true;

		return this.binderService.getVirtualBinderDigitalLogbook(activatedRouteSnapshot.paramMap.get('token'))
			.pipe(
				catchError(() => {
					this.router.navigate(['/404']);
					GlobalSettingsService.isSecondaryLoaderLoading = false;
					return NEVER;
				})
			);
	}
}
